// JavaScript Document
$(function () {
/*
======================
BODY FADE IN
======================
*/

	setTimeout(function () {
		$("body").removeClass("fade-out");
	}, 320);

	setTimeout(function () {
		$("body").addClass("loaded");
		$("#page-loader").fadeOut(900);
		$(".page-wrap").removeClass("fade-out");
	}, 1200);

/*
===============================
ADDITIONAL BODYCLASSES
===============================
*/

	if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
		$("html").addClass("safari");
	}

	/*
================================
SCROLL ANIMATIONS (WOW JS)
================================
*/

	var wow = new WOW({
		boxClass: "wow",
		animateClass: "animated",
		offset: 0,
		mobile: true,
		live: true,
		scrollContainer: null,
		resetAnimation: false,
	});
	wow.init();

	/*
=========================
OBJECT FIT
=========================
*/

	$(function () {
		objectFitImages("img.object-fit");
	});

	/*
=====================
TEL LINKS
=====================
*/

	//Disable on desktop (non touch)...
	$(".no-touch a.tel").on("click", function (e) {
		e.preventDefault();
	});

	/*
=====================
TABLE WRAPPER
=====================
*/

	$("table").wrap('<div class="table-wrap"></div>');

	/*
======================
IFRAME WRAPPER
======================
*/

	$(".page-section iframe").wrap('<div class="iframe-wrap"></div>');

	/*
===============================
FIXED HEADER
===============================
*/

	//add header class
	$(window).on("scroll", function () {
		if ($(this).scrollTop() > 1) {
			$("#masthead").addClass("scrolled");
		} else {
			$("#masthead").removeClass("scrolled");
		}
	});

	//check page position and add class if not at the top of page on load
	var pagePostion = $(window).scrollTop();

	if (pagePostion > 1) {
		$("#masthead").addClass("scrolled");
	} else {
		$("#masthead").removeClass("scrolled");
	}

	/*
======================
HAMBURGER MENU
======================
*/

	//open menu
	$(".menu-toggle").on("click", function () {
		$("body").toggleClass("mobile-navigation--open");
		$(this).toggleClass("active");
		$(".mobile-navigation").toggleClass("active");
	});

	$("#mobile-navigation .menu-item-has-children").append('<div class="menu-expand"><i class="fa-sharp fa-solid fa-chevron-down text-red"></i></div>');

	
	$(".menu-expand").on("click", function () {
		$(this).toggleClass("active");
		$(this).parent("li").toggleClass("active");
		$(this).parent("li").toggleClass("sub-menu-open");
		$(this).parent("li").find("> ul.sub-menu").slideToggle(600);
	});

	document.querySelectorAll('#mobile-navigation .sub-menu').forEach(item => {
		//add display none to style
		item.style.display = 'none';
	})

	//hover class
	$("#header-navigation ul li")
		.on("mouseenter", function () {
			$(this).addClass("active-hover");
		})
		.on("mouseleave", function () {
			$(this).removeClass("active-hover");
		});

	$(".main-menu .close").on("click", function () {
		$(".hamburger").removeClass("active");
		$(".main-menu").removeClass("active");
	});

	/*
================================
MENU AIM
================================
*/

	var $menu = $(".main-menu .desktop-menu ul");

	$menu.menuAim({
		activate: activateSubmenu,
		deactivate: deactivateSubmenu,
	});

	function activateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.children("a").addClass("hover");
		$submenu.css({display: "block"});
	}

	function deactivateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.find("a").removeClass("hover");
		$submenu.css("display", "none");
	}

	$(document).click(function () {
		$(".main-menu .desktop-menu ul li a.hover").removeClass("hover");
	});

	/*
=======================================
RESPONSIVE DATA TABLES
======================================
*/

	var tables = document.querySelectorAll(".page-section .table-wrap table");
	for (var a = 0; a < tables.length; a++) {
		var headertext = [];
		var headers = tables[a].querySelectorAll("thead td"),
			tablebody = tables[a].querySelector("tbody");

		for (var i = 0; i < headers.length; i++) {
			var current = headers[i];
			headertext.push(current.textContent.replace(/\r?\n|\r/, ""));
		}
		for (var i = 0, row; (row = tablebody.rows[i]); i++) {
			for (var j = 0, col; (col = row.cells[j]); j++) {
				col.setAttribute("data-th", headertext[j]);
			}
		}
	}

	/*
======================================
SMOOTH SCROLL
======================================
*/

	// SMOOTH SCROLLING FROM ANOTHER PAGE TO CORRECT ID
	//START AT TOP OF PAGE AND SCROLL DOWN ALWAYS
	if (window.location.hash) {
		setTimeout(function () {
			$("html, body").scrollTop(0).show();
			$("html, body").animate(
				{
					scrollTop: $(window.location.hash).offset().top - 0,
				},
				1000
			);
		}, 0);
	} else {
		$("html, body").show();
	}

	//SMOOTH SCROLLING
	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function (event) {
			// On-page links
			if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$("html, body").animate(
						{
							scrollTop: target.offset().top - 200,
						},
						1000,
						function () {
							// Callback after animation
							// Must change focus!
						}
					);
				}
			}
		});

	/*
=========================
ACCORDION
=========================
*/

$(document).on('click', '.faq-accordion .toggle-header', function(){
	var $block   = $(this).closest('.faq-accordion');
	var $item    = $(this).closest('.accordion-item');
	var $open    = $block.find('.accordion-item.active');

	// close others in *this* block only
	if ( ! $item.hasClass('active') ) {
	  $open
		.removeClass('active')
		.find('.toggle-icon').removeClass('rotate-45').end()
		.find('.toggle-content').slideUp('slow');
	}

	// toggle this one
	$item.toggleClass('active');
	$(this).find('.toggle-icon').toggleClass('rotate-45');
	$(this).next('.toggle-content').slideToggle('slow');
  });
  

	/*
=========================
UP ARROW
=========================
*/

	$(".up").on("click", function (event) {
		event.preventDefault();
		$("body,html").animate({scrollTop: 0}, 1000);
	});

	/*
==========================
BUTTONS
==========================
*/

	if ($("p .button").length > 0) {
		$("p").each(function () {
			if ($(this).find(".button").length === 2) {
				$(this).addClass("two-buttons");
			}
		});
	}

	/*
==========================
SLIDERS
==========================
*/

	//Banner Slider
	var swiper1 = new Swiper(".banner-slider .swiper", {
		/*navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},*/
		autoplay: true,
		loop: true,
		effect: "fade",
		slidesPerView: 1,
		spaceBetween: 50,
		centeredSlides: true,
		centeredSlidesBounds: true,
		navigation: false,
		pagination: {
			el: ".banner-slider .swiper-pagination",
		},
	});

	//Small Image slider
	var swiper2 = new Swiper(".swiper-6-slides", {
		slidesPerView: 3,
		spaceBetween: 10,
		navigation: {
			nextEl: ".small-image-slider .swiper-button-next",
			prevEl: ".small-image-slider .swiper-button-prev",
		},
		pagination: {
			el: ".small-image-slider .swiper-pag",
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				spaceBetween: 50,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 70,
			},
			1600: {
				slidesPerView: 6,
				spaceBetween: 100,
			},
		},
	});

	var swiper71 = new Swiper(".swiper-3-slides", {
		slidesPerView: 1,
		spaceBetween: 10,
		scrollbar: {
			el: ".swiper-scrollbar-3-slides",
			draggable: true,
		},	
		navigation: {
			nextEl: ".swiper-button-next.swiper-button-next-3-slides",
			prevEl: ".swiper-button-prev.swiper-button-prev-3-slides",
		},
		breakpoints: {
			900: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
		},
	});

	var swiper7 = new Swiper(".swiper-3-slides.test1", {
		slidesPerView: 1.2,
		spaceBetween: 10,
		navigation: {
			nextEl: ".swiper-button-next.test1.swiper-button-next-3-slides",
			prevEl: ".swiper-button-prev2.test1.swiper-button-prev-3-slides",
		},
		breakpoints: {
			600: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			800: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});

	//Large Image Slider
	var swiper3 = new Swiper(".mySwiper3", {
		spaceBetween: 20,
		slidesPerView: 3,
		freeMode: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: ".large-image-slider .swiper-button-next",
			prevEl: ".large-image-slider .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pag-2",
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 20,
			},
		},
	});

	var swiper4 = new Swiper(".mySwiper4", {
		slidesPerView: 1,
		// thumbs: {
		// 	swiper: swiper3,
		// },
	});

	swiper4.on("slideChange", () => {
		swiper3.slideTo(swiper4.activeIndex);
	});

	var swiper2 = new Swiper(".reviews-carousel", {
		slidesPerView: 1,
		spaceBetween: 50,
		loop: true,
		navigation: {
		  nextEl: ".reviews-section .swiper-button-next",
		  prevEl: ".reviews-section .swiper-button-prev",
		},
		pagination: {
		  el: ".reviews-section .swiper-pagination",
		  clickable: true,
		  // dynamicBullets: true, // uncomment if you want “growing” bullets
		},
		breakpoints: {
		  680: {
			slidesPerView: 1,
			spaceBetween: 40,
		  },
		  850: {
			slidesPerView: 2,
			spaceBetween: 80,
		  },
		  1280: {
			slidesPerView: 3,
			spaceBetween: 80,
		  },
		},
	  });
	  

	//Single Page Related Content
	var swiper5 = new Swiper(".related__swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		navigation: {
			nextEl: ".reviews .swiper-button-next",
			prevEl: ".reviews .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pag-4",
		},
		breakpoints: {
			600: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1600: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		},
	});

	/*
==========================
RECAPTCHA FADEOUT
==========================
*/

	$(window).on("scroll", function () {
		var documentHeight = $(document).height();
		var windowHeight = $(window).height();
		var scrollPosition = $(window).scrollTop();

		if (documentHeight - (windowHeight + scrollPosition) < 100) {
			$(".grecaptcha-badge").addClass("fade");
		} else {
			$(".grecaptcha-badge").removeClass("fade");
		}
	});

	/*
==========================
AJAX
==========================
*/

	//LOAD MORE POSTS
	$(".news-posts .posts-container").on("click", ".load-more", function (e) {
		e.preventDefault();

		var loaded = $("input.post-count").val();

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_posts",
				already_loaded: loaded,
			},
			beforeSend: function () {
				$(".news-posts .posts-container .load-more-posts").fadeTo(600, 0, function () {
					$(".news-posts .posts-container .load-more-posts").html('<div class="load"></div>');
				});
				$(".news-posts .posts-container .load-more-posts").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$(".news-posts .posts-container .load-more-posts")
					.delay(1000)
					.fadeOut(700, function () {
						$(".news-posts .posts-container .load-more-posts").remove();
						$(".news-posts .posts-container").append(data);
					});
			},
		});
	});
}); //end document.ready


// assets/js/map-tooltips.js

// assets/js/map-tooltips.js

jQuery(document).ready(function ($) {
	let $activeWrapper = null;
  
	// Reposition tooltip so it never overflows viewport
	function reposition($wrapper) {
	  const $tip = $wrapper.find('.hotspotContent').first();
	  if (!$tip.length) return;
  
	  // reset centering
	  $tip.css({
		left: '50%',
		transform: 'translateX(-50%) translateY(-5px)'
	  });
  
	  const rect   = $tip[0].getBoundingClientRect();
	  const vw     = window.innerWidth;
	  const margin = 8;
	  let shiftX   = 0;
  
	  if (rect.left < margin) {
		shiftX = margin - rect.left;
	  } else if (rect.right > vw - margin) {
		shiftX = (vw - margin) - rect.right;
	  }
  
	  if (shiftX !== 0) {
		$tip.css('transform', `translateX(calc(-50% + ${shiftX}px)) translateY(-5px)`);
	  }
	}
  
	// Hide any open hotspot
	function hideAll() {
	  if ($activeWrapper) {
		$activeWrapper.removeClass('active');
		$activeWrapper.find('.hotspotContent')
		  .css({ opacity: 0, visibility: 'hidden' });
		$activeWrapper = null;
	  }
	  // reset dot positioning
	  $('.ihb-hotspot-dot').css('position', 'absolute');
	}
  
	// Show a specific hotspot
	function showWrapper($wrapper) {
	  $wrapper.addClass('active');
	  const $tip = $wrapper.find('.hotspotContent').first();
	  $tip.css({
		opacity: 1,
		visibility: 'visible',
		// initial centering
		left: '50%',
		transform: 'translateX(-50%) translateY(-5px)'
	  });
	  reposition($wrapper);
	  $activeWrapper = $wrapper;
	}
  
	// Attach cloned content (unchanged)
	$('.ihb-hotspot-dot').each(function () {
	  const $dot  = $(this);
	  const label = $dot.data('label');
	  const $item = $('#lists_attractions').find('#' + label);
	  if ($item.length) {
		const $cont = $('<div class="hotspot-associated-content"></div>');
		$cont.append($item.clone());
		$dot.after($cont);
	  }
	});
  
	// 1) Drop any mouseleave handlers — tooltips will no longer auto-hide on hover out.
  
	// 2) Click on a dot toggles its hotspot
	$(document).on('click', '.ihb-hotspot-dot', function (e) {
	  e.preventDefault();
	  e.stopPropagation();
  
	  const $wrapper = $(this).closest('.ihb-hotspot-dot-wrapper');
  
	  // If clicking the already-open hotspot, just close everything
	  if ($activeWrapper && $wrapper.is($activeWrapper)) {
		hideAll();
		// show all dots again
		$('.ihb-hotspot-dot-wrapper').show();
	  } else {
		// close any open one...
		hideAll();
		// hide all the dots except the one we clicked
		$('.ihb-hotspot-dot-wrapper').hide();
		$wrapper.show();
		// then open the new one
		showWrapper($wrapper);
	  }
	});
  
	// 3) Click anywhere else to close
	$(document).on('click', function (e) {
	  if (!$(e.target).closest('.ihb-hotspot-dot-wrapper').length) {
		hideAll();
		// restore all dots
		$('.ihb-hotspot-dot-wrapper').show();
	  }
	});
  });
  
  
  
  
  



const title = document.querySelector('.attractions-title--js-controlled');
// const infoBox = document.querySelector('single-attraction-info-box');

const handleTitleLogic = () => {
	if (window.innerWidth <= 767) {
		const mobileWrap = document.querySelector('.attractions-title-wrap-mobile');
		if (mobileWrap && title) {
					//move the title to be first child of .attractions-title-wrap-mobile
			mobileWrap.insertBefore(title, mobileWrap.firstChild);
					//move the info box in header to be last child of .attractions-title-wrap-mobile
			// mobileWrap.appendChild(infoBox);
		}
	} else {
		const desktopWrap = document.querySelector('.attractions-title-wrap-desktop');
		const desktopBanner = document.querySelector('.single-attraction-banner');
		if (desktopWrap && title) {
					//move the title to be first child of .attractions-title-wrap-desktop
			desktopWrap.insertBefore(title, desktopWrap.firstChild);
								//move the info box back to header
			// infoBox.insertBefore(title, desktopBanner.firstChild);
		}
	}
}

if(title){

	handleTitleLogic();

	window.addEventListener('resize', () => handleTitleLogic());
	
}


const bannerIcon = document.querySelector('.banner-icon');

if(bannerIcon){
	const bannerHeading = document.querySelector('.banner-content h1');

	if(bannerHeading){
		bannerHeading.insertBefore(bannerIcon, bannerHeading.firstChild);
		bannerHeading.style.display = 'flex';
	}
}

const basicBlocks = document.querySelectorAll('.basic-banner-block');

if(basicBlocks.length > 0){

	basicBlocks.forEach(block => {
		const bannerIcon = block.querySelector('.basic-banner-icon');
		const bannerHeading = block.querySelector(' h2');
		if(bannerHeading && bannerIcon){
			bannerHeading.insertBefore(bannerIcon, bannerHeading.firstChild);
			bannerHeading.style.display = 'flex';
		}
	})
}


const btnsPrimary = document.querySelectorAll('a.primary');

if(btnsPrimary.length > 0){
	btnsPrimary.forEach(btn => {
		//wrap child in span tags
		const text = btn.innerHTML;
		btn.innerHTML = `<span>${text}</span>`;
		//add wave div
		btn.innerHTML += '<div class="wave"></div>';
		//add overflow hidden
		btn.style.overflow = 'hidden';
		//add position relative
		btn.style.position = 'relative';
		//add class btn-primary-styles--blue to btn
		btn.classList.add('btn-primary-styles--blue');
	});
}
const btnsSecondary = document.querySelectorAll('a.secondary');

if(btnsSecondary.length > 0){
	btnsSecondary.forEach(btn => {
		//wrap child in span tags
		const text = btn.innerHTML;
		btn.innerHTML = `<span>${text}</span>`;
		//add wave div
		btn.innerHTML += '<div class="wave"></div>';
		//add overflow hidden
		btn.style.overflow = 'hidden';
		//add position relative
		btn.style.position = 'relative';
		//add class btn-primary-styles--blue to btn
		btn.classList.add('btn-primary-styles--blue');
	});
}

const btnsNav = document.querySelectorAll('.menu-item a');

console.log('btnsNav:', btnsNav);

if(btnsNav.length > 0){
	btnsNav.forEach(btn => {
		const text = btn.querySelector('span')?.innerHTML;
		if(text === 'Buy your Tickets'){

			btn.parentElement.style.display = 'flex';
			
			//add wave div
			btn.innerHTML += '<div class="wave"></div>';
			//add overflow hidden
			btn.style.overflow = 'hidden';
			//add position relative
			btn.style.position = 'relative';
			
			btn.style.display = 'inline-block';

			//add class btn-primary-styles--blue to btn
			btn.classList.add('btn-primary-styles--blue');
			btn.classList.add('primary');
		}
	});
}

//Manual overide for buttons that inside section with green bg or blue. 
const btnsGreen = document.querySelectorAll('.bg-lightSeaGreen a.primary, .bg-lightSeaGreen a.secondary');
// const btnsGreen = document.querySelectorAll('.bg-deepSeaGreen a.primary, .bg-deepSeaGreen a.secondary, .bg-lightSeaGreen a.primary, .bg-lightSeaGreen a.secondary');


if(btnsGreen.length > 0){
	btnsGreen.forEach(btn => {
		//add class btn-primary-styles--blue to btn
		btn.classList.remove('btn-primary-styles--blue');
		btn.classList.add('btn-primary-styles--white');
	});
}